import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';

const Banner = () => {

    return (
        <div id="banner">
            <Carousel fade>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-2.jpg"
                        alt="First slide"
                    />
                    <Carousel.Caption>
                        <h6>ENGINE DIAGNOSTIC</h6>
                        <small>You need your car, and when you leave it in the shop for repairs, you can't help worrying about the cost.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-3.jpg"
                        alt="Second slide"
                    />

                    <Carousel.Caption>
                        <h6>OIL CHANGING</h6>
                        <small>If you suspect that the repair shop has not properly repaired the vehicle or charged you too much and you can't get them to resolve the problem to your satisfaction</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-4.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>BRAKE REPAIRING</h6>
                        <small>If you notice the same problem with your car is recurring, or find a new problem that should not have arisen.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-5.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>WIPER BLADE REPLACEMENT</h6>
                        <small>The shop fails to notify you and secure your additional approval, in writing, for any additional work to be done that was not set forth.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-6.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REPLACE AIR FILTER</h6>
                        <small>Your best protection from fraud and faulty repair work is to find a reputable mechanic or repair shop before your car needs to be repaired.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-7.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>SCHEDULED MAINTENANCE</h6>
                        <small>The authorization to commence repairs should also include the date and time that you signed the form. If you decide to have repairs made.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-8.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>BATTERY REPLACEMENT</h6>
                        <small>Have the shop write out the reasons for the difference in cost, and keep this written explanation together with the work estimate.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-9.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>ANTI-FREEZE ADDED</h6>
                        <small>You should not disclose your credit card account number, driver's license number, or any other personal information unless you clearly specify that giving the information.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-10.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>SPARK PLUG REPLACEMENT</h6>
                        <small>The shop starts repair work before obtaining written approval of the loan from the finance company.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-11.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>OID FILTER CHANGED</h6>
                        <small>To dispute the charge, you must do so in writing to your credit card company and it must be done within 60 days after you have received the credit card bill.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-12.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>ANTI-FREEZE ADDED</h6>
                        <small>You must do so in writing to your credit card company and it must be done within 60 days after you have received the credit card bill.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-13.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>BRAKE WORK</h6>
                        <small>If you paid by credit card and are unhappy with the repairs that were performed by the mechanic, then you may dispute the charge with your credit card company.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-14.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>NEW TIRES</h6>
                        <small>You should get a written authorization to tow, inspect, test drive, diagnose, or disassemble any part of your car for the purposes of providing an estimate of repair costs.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-15.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING SPARK PLUGS</h6>
                        <small>The shop says it will provide a free rental car during repairs and then requires you to pay for the rental charges..</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-16.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REPLACING A HEAD OR TAIL LIGHT</h6>
                        <small>Deceptive shops will extract this personal information from you, commence work without your authorization.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-17.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING CAR BATTERY</h6>
                        <small>You should not allow your car to be inspected, disassembled, or lifted up on a rack until you have obtained a copy of the inspection authorization.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-18.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REPLACING AIR FILTERS</h6>
                        <small>If you suspect that the repair shop has not properly repaired the vehicle or charged you too much.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-19.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>ENGINE DIAGNOSTIC</h6>
                        <small>You should not allow anyone to speak for you in negotiating car repairs on your vehicle. Deceptive shops will use this as an excuse to add on extra charges.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-20.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REMOVING SCRATCHES FROM THE PAINT</h6>
                        <small>You must do so in writing to your credit card company and it must be done within 60 days.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-21.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING A FLAT TYRE</h6>
                        <small>The shop represents that repair services will be completed by a certain day in order to induce the sale, then fails to have the repair.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-22.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING OIL</h6>
                        <small>You need your car, and when you leave it in the shop for repairs, you can't help worrying about the cost and the quality of the work that's going on under the hood.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-23.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>SCHEDULED MAINTENANCE</h6>
                        <small>The shop advertises "Free towing" and then requires you to pay for your towing costs. Give the second mechanic.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-24.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>ENGINE DIAGNOSTIC</h6>
                        <small>If you suspect that the repair shop has not properly repaired the vehicle or charged you too much and you can't get them.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-25.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>TYRE CHECK AND ROTATION</h6>
                        <small>The shop says it will provide a free rental car during repairs and then requires you to pay for the rental chargesGive the second mechanic.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-26.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>WIPER BLADES REPLACEMENT</h6>
                        <small>The shop says they will provide repair services pursuant to a warranty then charges you for repair work covered by the warranty.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-27.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REPACING CAR BATTERY</h6>
                        <small>The shop starts repair work before obtaining written approval of the loan from the finance companys.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-28.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING CAR WINDOW</h6>
                        <small>The shop fails to notify you and secure your additional approval, in writing, for any additional work to be done.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-29.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>COOLANT FLUSH</h6>
                        <small>If the charge is much higher than the estimate, or if the work was done without your authorization and you feel that you have been overcharged, question the bill.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-30.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>AIR CONDITIONER FILTER CHECK</h6>
                        <small>If the charge is much higher than the estimate, or if the work was done without your authorization.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-31.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>ENGINE DIAGNOSTIC</h6>
                        <small>If you suspect that the repair shop has not properly repaired the vehicle or charged you too much and you can't get them.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-32.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>TYRE CHECK AND ROTATION</h6>
                        <small>Give the second mechanic a copy of your itemized receipt and order an inspection of the alleged repairs and parts.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-33.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>TRANSMISSION SERVICES</h6>
                        <small>If you paid by credit card and are unhappy with the repairs that were performed by the mechanic.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-34.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>CHANGING A FLAT TYRE</h6>
                        <small>you must do so in writing to your credit card company and it must be done within 60 days after you have received the credit card bill.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-35.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REMOVING SCRATCHES FROM THE PAINT</h6>
                        <small>Before you go to the repair shop and the engine check light is on, consider taking it to an auto parts store who may run a computer diagnostic.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-36.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>NEW TIRES</h6>
                        <small>Do your homework to check on a repair shop’s reputation online and with friends and family. When you're researching repair shops, you can also find out.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-37.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>REPLACING A HEAD OR TAIL LIGHT</h6>
                        <small>Your best protection from fraud and faulty repair work is to find a reputable mechanic or repair shop.</small>
                    </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100"
                        src="./images/car-services/car-service-2.jpg"
                        alt="Third slide"
                    />

                    <Carousel.Caption>
                        <h6>BRAKE WORK</h6>
                        <small>You need your car, and when you leave it in the shop for repairs, you can't help worrying about the cost and the quality of the work that's going on under the hood.</small>
                    </Carousel.Caption>
                </Carousel.Item>
            </Carousel>
        </div>
    );
};

export default Banner;